<template>
  <v-app id="app" :dark="goDark">
    <div class="home">
      <div class="nav d-block">
        <div class="logo" :style="'filter: invert(' + (goDark ? 100 : 0) + '%)'">
          <img alt="Vue logo" src="./assets/logo.png" @click="darkSwitch">
        </div>
      </div>
      <router-view/>
    </div>
  </v-app>
</template>

<script>
export default {
  data: function () {
    return {
      goDark: false,
    }
  },
  mounted () {
    // this.goDark = true;
    // this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  },
  methods: {
    darkSwitch: function () {
      this.goDark = !this.goDark;
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.nav {
    height: 75px;
    border-bottom: solid 1px #c5c5c5;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav .logo {
    height: 50px;
  }

  .nav .logo img {
    height: 100%;
  }
</style>
